/**
 * Trimmed /v1/search display sample for the landing page.
 *
 * Source: apps/scrapers sold-search.html.gz fixture (captured 2026-07-26),
 * keyword "baseball caps", run through `toSoldRow`. Two real rows + omission
 * marker, not hand-written ideals (see competitor-soldcomps.md §4).
 */

/** Pretty display JSON. Two real items; comment is display-only. */
export const SAMPLE_SEARCH_JSON = `{
  "keyword": "baseball caps",
  "page": 1,
  "sold": true,
  "country": "US",
  "currency": "USD",
  "totalItems": 50,
  "cardsOnPage": 50,
  "hasNextPage": true,
  "windowStart": null,
  "items": [
    {
      "itemId": "117208227821",
      "title": "Black dog green clover adjustable woman's baseball hat",
      "url": "https://www.ebay.com/itm/117208227821",
      "soldPrice": 9.5,
      "soldDate": "2026-07-25",
      "currency": "USD",
      "shipping": 5.73,
      "shippingType": "paid",
      "condition": "New (Other)"
    },
    {
      "itemId": "236924970583",
      "title": "Womens Avid Fishing Baseball Cap Snapback Hat Mesh Back Floral Marine Life Color",
      "url": "https://www.ebay.com/itm/236924970583",
      "soldPrice": 24.99,
      "soldDate": "2026-07-25",
      "currency": "USD",
      "shipping": 0,
      "shippingType": "free",
      "condition": "Pre-Owned"
    }
    // … 48 more
  ],
  "fetchedAt": "2026-07-26T12:00:00.000Z"
}`;
